<template>
  <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.pageIndex" :page-sizes="pageSizes" :page-size="pagination.pageSize" :layout="layout" :total="pagination.dataCount">
  </el-pagination>
</template>

<script>
export default {
  props: {
    pagination: {
      type: Object,
      default: function () {
        return Object
      }
    },
    layout: {
      type: String,
      default: "total,sizes,prev,pager,next,jumper",
    },
    pageSizes: {
      type: Array,
      default: () => {
        return [10, 15, 20, 50, 100];
      }
    }
  },
  data() {
    return {
      pageIndex: 1,
      pageSize: 15,
    }
  },
  watch: {
    pagination: function (newValue) {
      this.pageSize = newValue.pageSize;
    }
  },
  mounted() {
    this.pageSize = this.pagination.pageSize;
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      if (Math.ceil(this.pagination.dataCount / val) < this.pageIndex) return;
      this.$emit("handleSizeChange", { pageIndex: this.pageIndex, pageSize: this.pageSize });
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.$emit("handleCurrentChange", { pageIndex: this.pageIndex, pageSize: this.pageSize });
    },

  }
}
</script>

<style>
.el-pagination {
  margin-top: 15px;
  /* text-align: right; */
}
</style>



// WEBPACK FOOTER //
// src/components/ListPagination.vue